import { useRef } from "react";

export function useUpdateOnChange(val: any) {
  const prev = useRef(val);
  const change = prev.current != val;
  prev.current = val;
  return change;
}
